let cartDrawer = document.querySelector(".cart-drawer");
let addToCartButton = document.querySelectorAll(".add-to-cart-button");
let productPairing = document.querySelectorAll('.pairing-product');

function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.add("hidden");
  cartDrawer.setAttribute("inert", "");
  document.documentElement.classList.remove('overflow-hidden');
  document.body.classList.remove('overflow-hidden');
}

document.addEventListener("click", (e) => {
  const addButton = e.target.closest(".quick-buy-button");
  if (!addButton) return;

  e.preventDefault();

  const card = addButton.closest(".collection-card, .quick-view-modal");
  if (!card) return;

  let variantID = null;
  let quantity = 1;

  const multiSelect = card.querySelector(".multi-variant-select[data-variant-id]");
  if (multiSelect) {
    variantID = multiSelect.getAttribute("data-variant-id");
  }

  if (!variantID) {
    const checkedInput = card.querySelector(".simple-variant-picker input:checked");
    if (checkedInput) variantID = checkedInput.value || checkedInput.id || null;
  }

  if (!variantID) {
    console.warn("⚠️ Variant ID not found for:", card);
    return;
  }

  const isModal = card.classList.contains("quick-view-modal");

  if (isModal) {
    const qtyEl = card.querySelector(".product-qty .selected");
    const dataQty = qtyEl?.dataset?.qtySelected;
    if (dataQty) {
      const q = parseInt(dataQty, 10);
      if (!Number.isNaN(q) && q > 0) quantity = q;
    } else {
      const span = card.querySelector(".product-qty .selected span");
      const txt = span?.innerText?.trim();
      const n = parseInt(txt, 10);
      if (!Number.isNaN(n) && n > 0) quantity = n;
    }
  } else {
    quantity = 1;
  }

  if (isModal && window.Alpine?.store("qv")) {
    window.Alpine.store("qv").close();
  }

  addItemToCart(variantID, quantity);
});

document.addEventListener("click", (e) => {
  if (e.target.closest(".show-cart-drawer")) {
    initCart();
    return;
  }
  if (e.target.closest(".cart-close-button")) {
    closeCartDrawer();
  }
});

window.addEventListener("pageshow", (e) => {
  if (e.persisted) closeCartDrawer();
});

const params = new URLSearchParams(window.location.search);

if (params.get("cart") === "open") {
  initCart();
}

if (productPairing.length > 0) {
  productPairing.forEach(item => {
    let button = item.querySelector('.pairing-add-to-card');
    button.addEventListener("click", function () {
      let variantID = item.querySelector('.variant-selected').getAttribute("data-variant-id");

      addItemToCart(variantID, 1);
    });
  });
}

if (addToCartButton.length > 0) {
  addToCartButton.forEach(button => {
    button.addEventListener("click", function () {
      let variantID = null;
      let quantity = null;
      const variantPicker = document.querySelector('.variant-picker') || null;
      if (variantPicker.classList.contains('multi-variant')) {
        variantID = document.querySelector('.multi-variant-select')?.getAttribute('data-variant-id');
        quantity = document.querySelector('.product-qty .selected')?.innerText || 1;
      } else if (variantPicker.classList.contains('simple-variant')) {
        variantID = document.querySelector('input[name="variant"]:checked')?.value;
        quantity = document.querySelector('.product-qty .selected')?.innerText || 1;
      } else {
        variantID = document.querySelector('.product-variant-id')?.value;
        quantity = document.querySelector('.product-qty')?.value || 1;
      }

      if (button.classList.contains('add-to-cart-gift-button')) {
        const format = getGiftCardFormat();
        let result;

        if (format === 'Digital') {
          result = validateGiftCardForm(format);
        } else {
          result = buildPhysicalGiftCardProperties(format);
        }

        const { isValid, properties } = result;

        if (!isValid) return;

        addGiftToCart(variantID, 1, properties);
      } else {
        addItemToCart(variantID, quantity);
      }
    });
  });
}

function getGiftCardFormat() {
  const checked = document.querySelector('input[name="format"]:checked');
  return checked ? checked.value : 'Digital';
}

function validateGiftCardForm(format = 'Digital') {
  const recipientName    = document.querySelector('#recipientName');
  const senderName       = document.querySelector('#senderName');
  const recipientEmail   = document.querySelector('#recipientEmail');
  const deliveryDate     = document.querySelector('#deliveryDate');
  const messageField     = document.querySelector('#message');

  const toError    = document.querySelector('#ToMessage');
  const fromError  = document.querySelector('#FromMessage');
  const emailError = document.querySelector('#EmailMessage');
  const dateError  = document.querySelector('#DateMessage');

  let isValid = true;

  function setError(input, errorEl, hasError) {
    if (!input || !errorEl) return;
    if (hasError) {
      errorEl.classList.remove('hidden');
      input.classList.add('border-red-500');
    } else {
      errorEl.classList.add('hidden');
      input.classList.remove('border-red-500');
    }
  }

  // To
  const toEmpty = !recipientName || !recipientName.value.trim();
  setError(recipientName, toError, toEmpty);
  if (toEmpty) isValid = false;

  // From
  const fromEmpty = !senderName || !senderName.value.trim();
  setError(senderName, fromError, fromEmpty);
  if (fromEmpty) isValid = false;

  const emailVal = recipientEmail ? recipientEmail.value.trim() : '';
  const emailInvalid =
    !emailVal ||
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
  setError(recipientEmail, emailError, emailInvalid);
  if (emailInvalid) isValid = false;

  if (deliveryDate) {
    const dateEmpty = !deliveryDate.value.trim();
    setError(deliveryDate, dateError, dateEmpty);
    if (dateEmpty) isValid = false;
  }

  if (!isValid) return { isValid: false, properties: null };

  const properties = {
    '_gc_format': format, // Digital
    '_gc_recipient_name': recipientName?.value || '',
    '_gc_recipient_from': senderName?.value || '',
    '_gc_recipient_email': emailVal || '',
    '_gc_delivery_date': deliveryDate?.value || '',
    '_gc_message': messageField?.value || '',
  };

  return { isValid: true, properties };
}

function buildPhysicalGiftCardProperties(format = 'Physical') {
  const messageField = document.querySelector('#message');

  const properties = {
    '_gc_format': format
  };

  if (messageField && messageField.value.trim()) {
    properties['_gc_message'] = messageField.value.trim();
  }

  return {
    isValid: true,
    properties
  };
}

function addItemToCart(variant_id, qty) {
  let data = {
    id: variant_id,
    quantity: Number(qty),
  };

  postAjax("/cart/add.js", data, function (response) {
    initCart();
  });
}

function addGiftToCart(variant_id, qty, properties) {
  let data = {
    id: variant_id,
    quantity: Number(qty),
  };

  // Flatten properties into form fields: properties[key]=value
  Object.keys(properties || {}).forEach((key) => {
    const val = properties[key];
    if (val !== undefined && val !== null && String(val).trim() !== '') {
      data[`properties[${key}]`] = val;
    }
  });

  postAjax("/cart/add.js", data, function (response) {
    initCart();
  });
}


function initCart() {
  cartDrawer.classList.remove("hidden");
  cartDrawer.removeAttribute("inert");
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden');

  fetch("/cart.js")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      renderCart(data);
    })
    .catch((error) => {
      alert("Error: " + error.message);
    });
}
window.initCart = initCart;

function renderCart(data) {
  let cartDrawer = document.querySelector(".cart-drawer");
  let cartContainer = document.querySelector(".cart-container");
  let cartCount = cartDrawer.querySelector(".cart-count");
  let cartTotal = cartDrawer.querySelectorAll(".cart-total");
  let emptyCartContainer = cartDrawer.querySelector(".empty-cart-container");
  let cartTotalHeader = document.querySelector(".cart-total-header");

  let freeShippingBar = cartDrawer.querySelector(".free-shipping-bar");
  let totalBlock = cartDrawer.querySelector(".cart-total-block");
  let checkoutContainer = cartDrawer.querySelector(".checkout-container");

  cartContainer.innerHTML = ""; // Clear previous content

  updateFreeShippingBar(data.total_price);

  cartTotalHeader.innerText = data.item_count;

  if (data.item_count === 0) {
    emptyCartContainer.classList.remove("hidden");
    freeShippingBar.classList.add("hidden");
    totalBlock.classList.add("hidden");
    checkoutContainer.classList.add("hidden");

    cartContainer.classList.add("hidden");
    cartCount.innerText = 0;
    cartTotal.forEach(el => el.innerText = `$0.00`);
    return;
  } else {
    emptyCartContainer.classList.add("hidden");

    freeShippingBar.classList.remove("hidden");
    totalBlock.classList.remove("hidden");
    checkoutContainer.classList.remove("hidden");

    cartContainer.classList.remove("hidden");
  }

  if (data.item_count === 1) {
    cartCount.innerText = `(${data.item_count} Item)`;
  } else {
    cartCount.innerText = `(${data.item_count} Items)`;
  }

  cartTotal.forEach(el => el.innerText = `$${(data.total_price / 100).toFixed(2)}`);

  data.items.forEach((item) => {
    let itemElement = document.createElement("div");
    itemElement.classList.add("cart-item");
    let memberLabel = '';

    item.discounts.forEach(discount => {
      if (discount.title == "MEMBER") {
        let amount = item.original_price - item.final_price;
        memberLabel = `Member (-$${(amount/100).toFixed(2)})`;
      }
    });
    console.log(item);

    itemElement.innerHTML = `
      <div class="flex items-stretch py-4 space-x-4 border-t cart-item border-munsell">
        <a href="${item.url}" aria-label="View ${item.title} product page">
           <img src="${item.image}" alt="${item.title}" class="w-[100px] h-[112px] object-cover">
        </a>
        <div class="flex flex-col flex-1 gap-2 justify-between">
          <div class="flex flex-col gap-1">
            <div class="text-[10px] text-darkGrey uppercase font-inter">${item.vendor}</div>
            
            <a href="${item.url}" aria-label="View ${item.title} product page">
              <h3 class="text-xs text-slate100 font-inter">${item.product_title}</h3>
            </a>
            
            <div class="flex justify-between">
              <p class="text-xs text-slate100 font-inter">${item.variant_title ? item.variant_title : ''}</p>
              <div class="flex items-center gap-2">
                <p class="text-xs text-slate100 font-inter line-through opacity-60">
                  ${ item.original_price && item.original_price > item.final_price
                      ? `$${(item.original_price/100).toFixed(2)}`
                      : ''
                    }
                </p>
                <p class="text-xs text-slate100 font-inter">$${(item.final_price / 100).toFixed(2)}</p>
              </div>
            </div>
            
            <div class="text-xs font-customLight text-right">${memberLabel}</div>
          </div>
          
          <div class="flex justify-between items-center mt-auto mb-0">
            <div class="border-[#EBE8E6] border rounded-md h-[33px] w-[86px] flex items-center p-2">
              <button class="flex-shrink-0 qty-minus" data-id="${item.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M3.33203 8.5H12.6654" stroke="#292B2E" stroke-linecap="square" stroke-linejoin="round"/></svg>
              </button>
              <input 
                type="text" 
                readonly 
                value="${item.quantity}" 
                class="w-full text-center font-inter text-xs cart-product-qty appearance-none bg-warnWhite [-webkit-appearance:none]"
              >
              <button class="flex-shrink-0 qty-plus" data-id="${item.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M7.9987 3.83203V13.1654M3.33203 8.4987H12.6654" stroke="#292B2E" stroke-linecap="square" stroke-linejoin="round"/></svg>
              </button>
            </div>
            
            <button class="delete-product-from-cart" data-id="${item.id}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M2 4.5H3.33333H14" stroke="#93979E" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.6654 4.4987V13.832C12.6654 14.1857 12.5249 14.5248 12.2748 14.7748C12.0248 15.0249 11.6857 15.1654 11.332 15.1654H4.66536C4.31174 15.1654 3.9726 15.0249 3.72256 14.7748C3.47251 14.5248 3.33203 14.1857 3.33203 13.832V4.4987M5.33203 4.4987V3.16536C5.33203 2.81174 5.47251 2.4726 5.72256 2.22256C5.9726 1.97251 6.31174 1.83203 6.66536 1.83203H9.33203C9.68565 1.83203 10.0248 1.97251 10.2748 2.22256C10.5249 2.4726 10.6654 2.81174 10.6654 3.16536V4.4987" stroke="#93979E" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66797 7.83203V11.832" stroke="#93979E" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.33203 7.83203V11.832" stroke="#93979E" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
          </div>
        </div>
      </div>
    `;

    cartContainer.appendChild(itemElement);

    // ----- Init delete product -----
    let deleteBtn = itemElement.querySelector(".delete-product-from-cart");
    deleteBtn.addEventListener("click", function () {
      const variantId = this.getAttribute("data-id");
      deleteProductFromCart(variantId);
    });

    // ----- Init qty minus -----
    let minusBtn = itemElement.querySelector(".qty-minus");
    let plusBtn = itemElement.querySelector(".qty-plus");
    let qtyInput = itemElement.querySelector(".cart-product-qty");

    minusBtn.addEventListener("click", function () {
      let currentQty = parseInt(qtyInput.value, 10);
      if (currentQty > 1) {
        updateProductQuantity(item.id, currentQty - 1);
      }
    });

    plusBtn.addEventListener("click", function () {
      let currentQty = parseInt(qtyInput.value, 10);
      updateProductQuantity(item.id, currentQty + 1);
    });
  });
}

function updateFreeShippingBar(subtotalInput) {
  const thresholdEl = document.querySelector('.free-shipping-threshold');
  const messageEl   = document.querySelector('.free-shipping-message');
  if (!thresholdEl || !messageEl) return;

  let maxPrice = parseFloat(thresholdEl.dataset.maxPrice);

  if (isNaN(maxPrice) || maxPrice <= 0) {
    thresholdEl.style.width = '0%';
    messageEl.textContent = '';
    return;
  }

  let currentRaw = parseFloat(
    String(subtotalInput).replace(/[^0-9.]/g, '')
  );
  if (isNaN(currentRaw)) currentRaw = 0;

  let current = currentRaw > maxPrice * 5 ? currentRaw / 100 : currentRaw;

  let remaining = Math.max(maxPrice - current, 0);
  let percent   = Math.max(0, Math.min((current / maxPrice) * 100, 100));

  thresholdEl.style.width = percent + '%';


  if (current >= maxPrice) {
    messageEl.innerHTML = `<span class="font-semibold">You unlocked free shipping!</span>`;
  } else {
    messageEl.innerHTML = `<span class="font-semibold">$${remaining.toFixed(2)}</span> away from free shipping.`;
  }
}

function updateProductQuantity(variantId, newQty) {
  let data = {
    id: variantId,
    quantity: newQty,
  };

  postAjax("/cart/change.js", data, function (data) {
    initCart();
  });
}

function deleteProductFromCart(variantId, callback) {
  let data = {
    id: variantId,
    quantity: 0,
  };

  postAjax("/cart/change.js", data, function (response) {
    if (callback) callback();
    initCart();
  });
}

function postAjax(url, data, success) {
  var params =
    typeof data == "string"
      ? data
      : Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
        })
        .join("&");

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open("POST", url);
  xhr.onreadystatechange = function () {
    if (xhr.readyState > 3 && xhr.status == 200) {
      success(xhr.responseText);
    }
  };
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.send(params);
  return xhr;
}

document.addEventListener('DOMContentLoaded', function () {
  const OFFSET = 100;

  function smoothScrollToHash(hash) {
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementPosition - OFFSET,
      behavior: 'smooth',
    });
  }

  if (window.location.hash && window.location.hash.length > 1) {
    window.scrollTo(0, 0);

    setTimeout(() => {
      smoothScrollToHash(window.location.hash);
    }, 300);
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');

    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    event.preventDefault();

    smoothScrollToHash(hash);

    history.pushState(null, '', hash);
  });

  window.addEventListener('hashchange', function () {
    smoothScrollToHash(window.location.hash);
  });
});